module.exports = __webpack_public_path__ + "static/img/yk4110.58fa4dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk4110.png
// module id = gf/v
// module chunks = 1